const categoriaToString = {}

function convertCategoriaToEString (eInt) {
  let eStr
  switch (eInt) {
    case '1':
      eStr = 'Inst.'
      break
    case '3':
      eStr = 'Sist.'
      break
    case '2':
      eStr = 'Admón.'
      break
    default:
      eStr = ''
      break
  }
  return eStr
}

categoriaToString.install = function (Vue) {
  Vue.filter('categoriaToHtml', (val) => {
    return convertCategoriaToEString(val)
  })
}



export default categoriaToString



// WEBPACK FOOTER //
// ./src/filters/categoria.js